require('./dist/floating-label/floating-label.css');
